import { defineService } from '@nzyme/ioc/Service.js';
import { computed } from 'vue';
import { CountryContext } from '@sigma/common/i18n/CountryContext.js';
import { parseLocale } from '@sigma/common/i18n/Locale.js';
import { DEFAULT_COUNTRY } from '@sigma/env/resources.js';
import { BrowserLocaleContext } from './BrowserLocaleContext.js';
/**
 * Browser country context.
 * Derives country from the current locale.
 */
export const BrowserCountryContext = defineService({
    name: 'BrowserCountryContext',
    implements: CountryContext,
    deps: {
        localeCtx: BrowserLocaleContext,
    },
    setup({ localeCtx }) {
        const country = computed(() => {
            const parsed = parseLocale(localeCtx.locale.value);
            return parsed?.country ?? DEFAULT_COUNTRY;
        });
        return () => country.value;
    },
});
//# sourceMappingURL=BrowserCountryContext.js.map